document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-offer-variant]');
  if (!select) return;
  const box = select.closest('[data-kloshy-offer]');
  const option = select.selectedOptions[0];
  box.querySelector('[data-offer-price]').textContent = option.dataset.price;
  const image = box.querySelector('.ko__image');
  if (option.dataset.image && image) {
    image.removeAttribute('srcset');
    image.src = option.dataset.image;
  }
});
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-kloshy-offer-form]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button');
  if (button.disabled) return;
  const error = form.querySelector('[role="alert"]');
  button.disabled = true;
  error.hidden = true;
  try {
    const result = await fetch(form.action + '.js', {method:'POST', body: new FormData(form), headers:{Accept:'application/json'}});
    if (!result.ok) throw new Error('add_failed');
    window.location.assign(form.elements.return_to.value);
  } catch {
    error.hidden = false;
    button.disabled = false;
  }
});
